// extracted by mini-css-extract-plugin
export default {"wrapper":"password-changed_wrapper__9+lU-","opacity-transition":"password-changed_opacity-transition__hY9WX"};